import { KeyRound } from 'lucide-react';
import { Link } from 'react-router-dom';

import { useConfig } from '@chainlit/react-client';

import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from '@/components/ui/tooltip';
import { Translator } from 'components/i18n';

export default function ApiKeys() {
  const { config } = useConfig();
  const requiredKeys = !!config?.userEnv?.length;

  if (!requiredKeys) return null;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Link to="/env">
            <Button
              id="api-keys-button"
              size="icon"
              variant="ghost"
              className="size-8 rounded-lg text-muted-foreground transition-colors duration-150 hover:bg-accent/80 hover:text-foreground focus-visible:ring-2 focus-visible:ring-primary/20"
            >
              <KeyRound className="!size-4 stroke-[1.9]" />
            </Button>
          </Link>
        </TooltipTrigger>
        <TooltipContent>
          <p>
            <Translator path="navigation.user.menu.apiKeys" />
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
